export default "__VITE_ASSET__DkvQwsFP__"